<style lang="less">
.app-header {
  color: rgba(49, 58, 70, 0.8);

  .h-autocomplete {
    line-height: 1.5;
    float: left;
    margin-top: 15px;
    margin-right: 20px;
    width: 120px;
    &-show,
    &-show:hover,
    &-show.focusing {
      outline: none;
      box-shadow: none;
      border-color: transparent;
      border-radius: 0;
    }
    &-show.focusing {
      border-bottom: 1px solid #eee;
    }
  }
  &-info &-icon-item {
    cursor: pointer;
    display: inline-block;
    float: left;
    padding: 0 15px;
    height: @layout-header-height;
    line-height: @layout-header-height;
    margin-right: 10px;
    &:hover {
      background: @hover-background-color;
    }
    i {
      font-size: 18px;
    }
    a {
      color: inherit;
    }
    .h-badge {
      margin: 20px 0;
      display: block;
    }
  }
  .h-dropdownmenu {
    float: left;
  }

  &-dropdown {
    float: right;
    margin-left: 10px;
    padding: 0 20px 0 15px;
    .h-icon-down {
      right: 20px;
    }
    cursor: pointer;
    &:hover,
    &.h-pop-trigger {
      background: @hover-background-color;
    }
    &-dropdown {
      padding: 5px 0;
      .h-dropdownmenu-item {
        padding: 8px 20px;
      }
    }
  }

  &-menus {
    display: inline-block;
    vertical-align: top;
    > div {
      display: inline-block;
      font-size: 15px;
      padding: 0 25px;
      color: @dark-color;
      &:hover {
        color: @primary-color;
      }
      + div {
        margin-left: 5px;
      }
      &.h-tab-selected {
        color: @white-color;
        background-color: @primary-color;
      }
    }
  }
}
</style>

<template>
  <div class="app-header">
    <div style="width: 50px; float: left">
      <Button
        :icon="siderCollapsed ? 'icon-align-right' : 'icon-align-left'"
        size="l"
        noBorder
        class="font20"
        @click="siderCollapsed = !siderCollapsed"
      ></Button>
    </div>
    <div class="float-right app-header-info">
      <AutoComplete
        style="width: 200px"
        :showDropdownWhenNoResult="false"
        v-model="searchText"
        config="globalSearch"
        placeholder="全局搜索.."
      ></AutoComplete>
      <Tooltip content="刷新页面 (F5)" theme="white">
        <div class="app-header-icon-item" @click="reloadPage">
          <i class="icon-reload"></i>
        </div>
      </Tooltip>
      <Tooltip content="系统布局配置" theme="white">
        <div class="app-header-icon-item" @click="showSettingModal">
          <i class="icon-content-left"></i>
        </div>
      </Tooltip>
      <appHeaderMessage></appHeaderMessage>
      <DropdownMenu
        className="app-header-dropdown"
        trigger="hover"
        offset="5,5"
        :width="150"
        placement="bottom-end"
        :datas="infoMenu"
        @clickItem="trigger"
      >
        <Avatar :src="user.avatar" :width="30"
          ><span>{{ user.username || user.name }}</span></Avatar
        >
      </DropdownMenu>
    </div>
  </div>
</template>
<script>
import appHeaderMessage from './modules/app-header-message';
import Request from '@common/request';
import utils from '@common/utils';
import { beginLogout } from '@common/ajax';
import { loadingBar } from 'heyui';
import { onMounted, onUnmounted } from 'vue';

export default {
  components: {
    appHeaderMessage
  },
  data() {
    return {
      searchText: '',
      infoMenu: [
        { key: 'info', title: '个人信息', icon: 'h-icon-user' },
        { key: 'logout', title: '退出登录', icon: 'h-icon-outbox' }
      ]
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    siderCollapsed: {
      get() {
        return this.$store.state.siderCollapsed;
      },
      set(value) {
        this.$store.commit('updateSiderCollapse', value);
      }
    }
  },
  setup(props, context) {
    let resizeEvent = null;
    onMounted(() => {
      let windowWidth = window.innerWidth;
      resizeEvent = window.addEventListener('resize', () => {
        if (windowWidth == window.innerWidth) {
          return;
        }
        if (context.siderCollapsed && window.innerWidth > 900) {
          context.siderCollapsed = false;
        } else if (!context.siderCollapsed && window.innerWidth < 900) {
          context.siderCollapsed = true;
        }
        windowWidth = window.innerWidth;
      });
    });
    onUnmounted(() => {
      window.removeEventListener('resize', resizeEvent);
    });
  },
  methods: {
    trigger(data) {
      if (data == 'logout') {
        beginLogout();
        const goLogin = () => {
          utils.removeLocal('token');
          utils.removeLocal('username');
          utils.removeLocal('SYS_USER_MENUS');
          utils.removeLocal('DESKTOP_SKIP_LOGIN');
          loadingBar.success();
          if (this.$route.name !== 'Login') {
            this.$router.replace({ name: 'Login' });
          }
        };
        Request.Login.logout().finally(goLogin);
      } else {
        this.$router.push({ name: 'AccountBasic' });
      }
    },
    showSettingModal() {
      this.$emit('openSetting');
    },
    reloadPage() {
      window.location.reload();
    },
    onReloadShortcut(event) {
      const key = event.key;
      if (key === 'F5' || ((event.ctrlKey || event.metaKey) && (key === 'r' || key === 'R'))) {
        event.preventDefault();
        this.reloadPage();
      }
    }
  },
  mounted() {
    window.addEventListener('keydown', this.onReloadShortcut);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onReloadShortcut);
  }
};
</script>
